<template>
  <back-to-top bottom="50px" right="50px">
    <button type="button" class="btn btn-info"><i class="fa fa-chevron-up"></i></button>
  </back-to-top>
</template>

<script>
export default {
  name: 'ToTopButton',
};
</script>
